import React from 'react'
import {Link, useLocation} from 'react-router-dom'
import { subdivisionListDataType } from './RestInfoDataType'

const RentInfoHome = ({subdivisionList, id}: {subdivisionList:subdivisionListDataType[], id:string | undefined}) => {
  const location = useLocation()
  return (
    <div className='card'>
      {/* mb-5 mb-xl-10 */}
      <div className='card-body pb-0 pt-2'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {subdivisionList.map((listObj, index) => {
              return (
                <li key={index} className='nav-item' >
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname ===
                        `/property/rent_info/${id}/${listObj.property_sub_unit_uuid}` &&
                        'active underline')
                    }
                    to={listObj.property_sub_unit_uuid}
                  >
                    {listObj.property_unit_name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default RentInfoHome
